module.exports = __webpack_public_path__ + "img/people.b5e4fb27.png";